module.exports = __webpack_public_path__ + "img/product3.03515746.jpg";